export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحرير"])}
        }
      },
      "ar-EG": {
        "edit": {
          
        }
      },
      "ar-SA": {
        "edit": {
          
        }
      },
      "de-DE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten"])}
        }
      },
      "de-AT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten"])}
        }
      },
      "de-CH": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten"])}
        }
      },
      "en-US": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])}
        }
      },
      "en-GB": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])}
        }
      },
      "it-IT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifica"])}
        }
      },
      "fr-FR": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])}
        }
      },
      "es-ES": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])}
        }
      },
      "pl-PL": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edytuj"])}
        }
      },
      "nl-NL": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bewerken"])}
        }
      },
      "bg-BG": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редактиране"])}
        }
      },
      "bs-BA": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uredi"])}
        }
      },
      "da-DK": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rediger"])}
        }
      },
      "et-EE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redigeeri"])}
        }
      },
      "fi-FI": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Muuta"])}
        }
      },
      "el-GR": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επεξεργασία"])}
        }
      },
      "he-IL": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ערוך"])}
        }
      },
      "ga-IE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir in eagar"])}
        }
      },
      "ja-JP": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["編集"])}
        }
      },
      "hr-HR": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Urediti"])}
        }
      },
      "lv-LV": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rediģēt"])}
        }
      },
      "lt-LT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redaguoti"])}
        }
      },
      "pt-PT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])}
        }
      },
      "ro-RO": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editare"])}
        }
      },
      "ru-RU": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редактировать"])}
        }
      },
      "sv-SE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redigera"])}
        }
      },
      "sk-SK": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upraviť"])}
        }
      },
      "cs-CZ": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upravit"])}
        }
      },
      "tr-TR": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Düzenle"])}
        }
      },
      "hu-HU": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szerkeszt"])}
        }
      },
      "fr-BE": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])}
        }
      },
      "fr-LU": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])}
        }
      },
      "mt-MT": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editja"])}
        }
      },
      "sl-SI": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uredi"])}
        }
      },
      "el-CY": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επεξεργασία"])}
        }
      },
      "tr-CY": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Düzenle"])}
        }
      },
      "uk-UA": {
        "edit": {
          
        }
      },
      "zh-CN": {
        "edit": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["编辑"])}
        }
      }
    }
  })
}
